import getScrollAccessor from './getScrollAccessor';
export default getScrollAccessor('pageYOffset');


//////////////////
// WEBPACK FOOTER
// ../~/dom-helpers/esm/scrollTop.js
// module id = 654
// module chunks = 121